<div class="flex gap-1 mb-3 bg-slate-100 p-1">
    <button *ngFor="let tab of tabList ; index as i" class="flex-1 px-3 py-2 font-bold transition-all duration-100 focus:outline-none hover:scale-105 hover:bg-blue-950 hover:text-white"
      [ngClass]="i+1 === step_details?.step_mapping?.phase_sequence ? 'bg-blue-950 text-white rounded transform scale-105 hover:scale-105' : 'bg-blue-50 text-blue-800  border-2 border-blue-600'">
      {{ tab.name }}
    </button>
  </div>
  
  <app-trans-header-steper *ngIf="topRender" (currentStepChange)="currentStepChange($event)"></app-trans-header-steper>
  
  <div class="mt-4">
    <div class="flex items-center justify-between mb-8 w-full">
      <div class="flex flex-nowrap items-center gap-1 bg-slate-200 p-1 rounded-xl border border-slate-300 shadow-sm overflow-x-auto">
        <ng-container *ngFor="let t of [
          { code: 'process', icon: 'pi-sitemap', txt: 'Process Flow', tip: 'View flow', action:'' },
          { code: 'comments', icon: 'pi-comments', txt: 'Comments', tip: 'View notes', action:'' },
          { code: 'report', icon: 'pi-file-pdf', txt: 'Reports', tip: 'Access reports', action:'getReportData' },
          { code: 'document', icon: 'pi-folder', txt: 'Documents', tip: 'Manage files', action:'getDocumentList' }
        ]">
          <button 
            class="px-4 py-1 rounded-lg font-bold text-sm transition-all duration-300 flex items-center gap-2.5 whitespace-nowrap"
            [ngClass]="userGuide === t.code
              ? 'bg-slate-100 text-blue-700 shadow-md ring-1 ring-slate-300'
              : 'text-slate-700 hover:text-blue-700 hover:bg-slate-100/80'"
            (click)="userGuide = t.code; t.action && this[t.action]()"
            [pTooltip]="t.tip" tooltipPosition="top">
            
            <i class="pi text-base" [ngClass]="[t.icon, userGuide === t.code ? 'text-blue-700' : 'text-slate-500']"></i>
            <span>{{ t.txt }}</span>
          </button>
        </ng-container>
      </div>
 
    </div>
  
    <!-- Content Grid -->
    <div class="mt-3">
      <div class="grid grid-cols-1">
          <div *ngIf="userGuide === 'process'">
            <div class="bg-white rounded-xs shadow" *ngIf="step_details">
             
              <ng-container *ngIf="step_details?.step_mapping?.scheme?.code === 'OC' && ['U-PC','SCR-APP','S-C','C-APPR'].includes(step_details?.code) ; else openContainer">
                <!-- oc Upload Challenge -->
                     <app-idex
                     *ngIf="step_details.code === 'U-PC'"
                     (generatePDFEmitter)="generatePDF($event)"
                     (routeConfig)="showConfirm()"
                     [stepDetails]="step_details"
                     [type]="'approval'"
                     [url]="`/idex/oc/upload/challenges/?proposal_step=${step_details.id}&proposal_step__proposal=${step_details.proposal}`"
                     [schemeType]="'idex'">
                   </app-idex>
                   <app-idex
                     *ngIf="step_details.code === 'SCR-APP'"
                     (generatePDFEmitter)="generatePDF($event)"
                     (routeConfig)="showConfirm()"
                     [stepDetails]="step_details"
                     [url]="`/idex/oc/screening/application/?proposal_step=${step_details.id}&proposal_step__proposal=${step_details.proposal}`"
                     [type]="'approval'"
                     [schemeType]="'idex'">
                   </app-idex>
                   <app-idex
                     *ngIf="step_details.code === 'S-C'"
                     (generatePDFEmitter)="generatePDF($event)"
                     (routeConfig)="showConfirm()"
                     [stepDetails]="step_details"
                     [url]="`/idex/oc/shortlisting/application/?proposal_step=${step_details.id}&proposal_step__proposal=${step_details.proposal}`"
                     [type]="'approval'"
                     [schemeType]="'idex'">
                   </app-idex>
                   <app-idex
                     *ngIf="step_details.code === 'C-APPR'"
                     (generatePDFEmitter)="generatePDF($event)"
                     (routeConfig)="showConfirm()"
                     [stepDetails]="step_details"
                     [url]="`/idex/oc/challenge/approval/?proposal_step=${step_details.id}&proposal_step__proposal=${step_details.proposal}`"
                     [type]="'approval'"
                     [schemeType]="'idex'">
                   </app-idex>
             </ng-container>
             <ng-template #openContainer>
               <ng-container [ngSwitch]="step_details?.code">
                 
                 <!-- idex_001 -->
                 <app-idex
                   *ngSwitchCase="'idex_001'"
                   (generatePDFEmitter)="generatePDF($event)"
                   (routeConfig)="showConfirm()"
                   [stepDetails]="step_details"
                   [url]="`/idex/challenges/`"
                   [schemeType]="'idex'">
                 </app-idex>
                
                 
                 
                 <!-- I-SC -->
                  
                 <app-idex
                   *ngSwitchCase="'I-SC'"
                   (generatePDFEmitter)="generatePDF($event)"
                   (routeConfig)="showConfirm()"
                   [stepDetails]="step_details"
                   [url]="`/idex/screening/challenge/`"
                   [schemeType]="'idex'">
                 </app-idex>
             
                 <!-- C-APPR -->
                 <app-idex
                   *ngSwitchCase="'C-APPR'"
                   (generatePDFEmitter)="generatePDF($event)"
                   (routeConfig)="showConfirm()"                    
                   [stepDetails]="step_details"
                   [url]="`/idex/challenge/approval/`"
                   [schemeType]="'idex'"
                   >
                 </app-idex>
                 <!-- IP-V -->
                 <app-idex
                   *ngSwitchCase="'IPV'"
                   (generatePDFEmitter)="generatePDF($event)"
                   (routeConfig)="showConfirm()"                    
                   [stepDetails]="step_details"
                   [url]="`/idex/ip/valuation/`"
                   [schemeType]="'idex'">
                 </app-idex>
                
             
             
                 <!-- L-CH -->
                 <app-launch-challenge
                   *ngSwitchCase="'L-CH'"                    
                   (generatePDFEmitter)="generatePDF($event)"
                   (routeConfig)="showConfirm()"                    
                   [stepDetails]="step_details"                   
                   [schemeType]="'idex'">
                 </app-launch-challenge>
             
                 <!-- I-UP -->
                 <app-firm-response-submission
                   *ngSwitchCase="'I-UP'"                    
                   [schemeType]="'idex'"
                   [stepDetails]="step_details"                   
                   [format]="'upload'"
                   [isVisibleResponseUpload]="true"
                   [url]="'/idex/dms-file/vendor/'"
                   (routeConfig)="showConfirm()">
                 </app-firm-response-submission>
                 
                 <!-- idex_004 -->
                 <app-constitute-committee
                 *ngSwitchCase="'idex_004'"
                      [id]="step_details.id"
                      [step]="step_details"
                      [title]="'Constitute HPSC , PFT Committee'"
                      [getUrl]="'revenue/constitute-committee/'"
                      [postUrl]="'revenue/constitute-committee/'"
                      (generatePDFEmitter)="generatePDF($event)"
                      
                      (routeConfig)="showConfirm()"
                      [stepDetails]="step_details">
               </app-constitute-committee>
 
               <!-- idex_005 -->
               
               <app-firm-response-evaluation
               *ngSwitchCase="'idex_005'"                    
               [schemeType]="'idex'"
               [stepDetails]="step_details"                   
               [type]="'evaluation'"
               [url]="'/idex/dms-file/vendor/'"
               (routeConfig)="showConfirm()">
             </app-firm-response-evaluation>
             
             <app-firm-response-submission
             *ngSwitchCase="'SCR-APP'"                    
             [schemeType]="'idex'"
             [isVisibleResponseUpload]="true"
             [stepDetails]="step_details"                   
             [format]="'screening'"
             [url]="'/idex/dms-file/vendor/'"
             (routeConfig)="showConfirm()">
           </app-firm-response-submission>
           
             
                 <!-- idex_006 -->
                 <app-idex-winners
                   *ngSwitchCase="'idex_006'"
                   [data]="step_details?.winner"
                   [proposalName]="proposalName"
                   [proposalId]="proposalId"
                   (generatePDFEmitter)="generatePDF($event)"
                   (routeConfig)="showConfirm()"
                   [step]="step_details"
                   [stepDetails]="step_details">
                 </app-idex-winners>
             
                 <!-- IPV -->
             
                 <!-- I-PS -->
                 <app-share-pds-pru
                   *ngSwitchCase="'I-PS'"
                   [id]="step_details.id"
                   (routeConfig)="showConfirm()"
                   [proposalName]="proposalName"
                   [proposalId]="proposalId"
                   [stepDetails]="step_details"
                   [schemeType]="'idex'">
                 </app-share-pds-pru>
             
                 <!-- I-UPS -->
                 <!-- <app-upload-pds-pru
                   *ngSwitchCase="'I-UPS'"
                   (generatePDFEmitter)="generatePDF($event)"
                   [id]="step_details.id"
                   [proposalName]="proposalName"
                   [proposalId]="proposalId"
                   [format]="'upload'"
                   [stepDetails]="step_details">
                 </app-upload-pds-pru> -->
                 <app-firm-response-submission
                       *ngSwitchCase="'I-UPS'"                    
                       [schemeType]="'idex'"
                       [stepDetails]="step_details"                   
                       [format]="'pds-pru-evaluation'"
                       [url]="'/idex/dms-file/vendor/'"
                       (routeConfig)="showConfirm()">
               </app-firm-response-submission>

                   <app-technical-negotiations
                *ngSwitchCase="'R-TN'"
                [id]="step_details?.id"
                [step]="step_details"
                [getUrl]="'/idex/technical-negotiation/?proposal_step='"
                [postUrl]="'/idex/technical-negotiation/'"
                (generatePDFEmitter)="generatePDF($event)"
                [schemeType]="'idex'"
                [stepDetails]="step_details"
                (routeConfig)="showConfirm()"
              >
              </app-technical-negotiations>
 
                  <!-- I-TE (bids upload) -->
                  <app-firm-response-submission
                       *ngSwitchCase="'I-TE'"                    
                       [schemeType]="'idex'"
                       [stepDetails]="step_details"                   
                       [format]="'pds-pru'"
                       [url]="'/idex/dms-file/vendor/'"
                       (routeConfig)="showConfirm()">
                </app-firm-response-submission>
             
                 <!-- idex_014 (bids) -->
                 <app-idex-bids
                   *ngSwitchCase="'idex_014'"
                   (generatePDFEmitter)="generatePDF($event)"
                   [id]="step_details.id"
                   [proposalName]="proposalName"
                   [proposalId]="proposalId"
                   [stepDetails]="step_details">
                 </app-idex-bids>
             
              
             
                 <!-- I-UDA -->
                 <app-spark-agreement
                   *ngSwitchCase="'I-UDA'"
                   [getUrl]="'revenue/final-offer/'"
                   [postUrl]="'revenue/final-offer/'"
                   (generatePDFEmitter)="generatePDF($event)"
                   [stepDetails]="step_details"
                   (routeConfig)="showConfirm()"
                   [schemeType]="'idex'">
                 </app-spark-agreement>
             
                 <!-- RFP-V -->
                 <app-pre-rfp-meeting
                   *ngSwitchCase="'RFP-V'"
                   [id]="step_details.id"
                   [step]="step_details"
                   [getUrl]="'revenue/pre-rfp-meeting/'"
                   [postUrl]="'revenue/pre-rfp-meeting/'"
                   (generatePDFEmitter)="generatePDF($event)"
                   [schemeType]="'idex'"
                   [stepDetails]="step_details">
                 </app-pre-rfp-meeting>
             
                 <!-- I-RFP -->
                 <app-idex-commercial-rfp
                   *ngSwitchCase="'I-RFP'"
                   [id]="proposalId"
                   [step]="step_details"
                   [proposalName]="proposalName"
                   (generatePDFEmitter)="generatePDF($event)"      
                   [stepDetails]="step_details">
                 </app-idex-commercial-rfp>
             
                 <!-- tdf_005 -->
                 <app-constitute-committee
                   *ngSwitchCase="'tdf_005'"
                   [id]="step_details.id"
                   [step]="step_details"
                   [title]="'Constitute Committee'"
                   [getUrl]="'revenue/constitute-committee/'"
                   [postUrl]="'revenue/constitute-committee/'"
                   (generatePDFEmitter)="generatePDF($event)"
                   [stepDetails]="step_details">
                 </app-constitute-committee>
             
                 <!-- R-BM -->
                 <app-banchmark
                   *ngSwitchCase="'R-BM'"
                   [id]="step_details.id"
                   [step]="step_details"               
                   (generatePDFEmitter)="generatePDF($event)"
                   [stepDetails]="step_details"
                   (routeConfig)="showConfirm()">
                 </app-banchmark>
             
                 <!-- tdf_006 -->
                 <app-commercial-negocatition
                   *ngSwitchCase="'tdf_006'"
                   [id]="step_details.id"
                   [step]="step_details"               
                   (generatePDFEmitter)="generatePDF($event)"
                   [stepDetails]="step_details"
                   [schemeType]="'idex'">
                 </app-commercial-negocatition>
             
                 <!-- R-PSO -->
                 <app-sanction-order
                   *ngSwitchCase="'R-PSO'"
                   [id]="step_details.id"
                   [step]="step_details"   
                   (generatePDFEmitter)="generatePDF($event)"
                   [stepDetails]="step_details"
                   [schemeType]="'idex'">
                 </app-sanction-order>
             
                 <!-- makeI_07 -->
                 <app-psqr
                   *ngSwitchCase="'makeI_07'"
                   [id]="step_details.id"
                   [proposalName]="proposalName"
                   [proposalId]="proposalId"
                   (routeConfig)="showConfirm()"
                   (generatePDFEmitter)="generatePDF($event)"
                   [stepDetails]="step_details"
                   [schemeType]="'idex'">
                 </app-psqr>
             
                 <!-- makeI_23 -->
                 <app-psqr-to-sqr
                   *ngSwitchCase="'makeI_23'"
                   (routeConfig)="showConfirm()"
                   (generatePDFEmitter)="generatePDF($event)"
                   [stepDetails]="step_details"
                   [schemeType]="'idex'">
                 </app-psqr-to-sqr>
             
                 <!-- U-BS -->
                 <app-upload-wbs
                   *ngSwitchCase="'U-BS'"
                   [proposalName]="proposalName"
                   (routeConfig)="showConfirm()"
                   [id]="step_details.id"
                   [step]="step_details"
                   [stepDetails]="step_details"
                   [proposalId]="proposalId">
                 </app-upload-wbs>
             
                 <!-- M-WBS -->
                 <app-map-wbs-payment
                   *ngSwitchCase="'M-WBS'"
                   [proposalName]="proposalName"
                   (generatePDFEmitter)="generatePDF($event)"
                   (routeConfig)="showConfirm()"
                   [id]="step_details.id"
                   [step]="step_details"
                   [stepDetails]="step_details"
                   [proposalId]="proposalId">
                 </app-map-wbs-payment>
             
                 <!-- I-SSCT -->
                 <app-constitute-committee
                   *ngSwitchCase="'I-SSCT'"
                   [id]="step_details.id"
                   [step]="step_details"
                   [title]="'Constitute SSCT'"
                   (routeConfig)="showConfirm()"
                   [getUrl]="'revenue/constitute-committee/'"
                   [postUrl]="'revenue/constitute-committee/'"
                   (generatePDFEmitter)="generatePDF($event)"
                   [stepDetails]="step_details">
                 </app-constitute-committee>
             
                 <!-- make1_009 -->
                 <app-ssct
                   *ngSwitchCase="'make1_009'"
                   [proposalName]="proposalName"
                   (generatePDFEmitter)="generatePDF($event)"
                   [id]="step_details.id"
                   [step]="step_details"
                   (routeConfig)="showConfirm()"
                   [stepDetails]="step_details"
                   [proposalId]="proposalId">
                 </app-ssct>
             
                 <!-- AoNSoC -->
                 <app-aon-soc
                   *ngSwitchCase="'AoNSoC'"
                    [id]="step_details.id"
                   [step]="step_details"
                   (routeConfig)="showConfirm()"
                   [proposalId]="proposalId"
                   [stepDetails]="step_details"
                   >
                 </app-aon-soc>
             
                 <!-- idex_002 -->
                 <app-idex-sqr
                   *ngSwitchCase="'idex_002'"
                   (generatePDFEmitter)="generatePDF($event)"
                   [id]="step_details.id"
                   [stepDetails]="step_details">
                 </app-idex-sqr>
             
                 <!-- R-VI -->
                 <app-vendor
                   *ngSwitchCase="'R-VI'"
                   [id]="step_details.id"
                   [step]="step_details"
                   [schemeType]="'idex'"
                   [stepDetails]="step_details">
                 </app-vendor>
             
                 <!-- idex_007 -->
                 <app-idex-prototype
                   *ngSwitchCase="'idex_007'"
                   [data]="step_details?.winner"
                   [proposalName]="proposalName"
                   [proposalId]="proposalId"
                   [step]="step_details"
                   (generatePDFEmitter)="generatePDF($event)"
                   [schemeType]="'idex'"
                   [stepDetails]="step_details">
                 </app-idex-prototype>
             
                 <!-- idex_009 -->
                 <app-idex-utrr
                   *ngSwitchCase="'idex_009'"
                   (generatePDFEmitter)="generatePDF($event)"
                   [step]="step_details"
                   [data]="step_details?.winner"
                   [id]="step_details?.id"
                   [stepDetails]="step_details"
                   [schemeType]="'idex'">
                 </app-idex-utrr>
             
                 <!-- R-RFP-SOC -->
                 <app-idex-rfp-soc
                   *ngSwitchCase="'R-RFP-SOC'"
                   (generatePDFEmitter)="generatePDF($event)"
                   [proposalName]="proposalName"
                   [masterData]="masterData"
                   [step]="step_details"
                   [stepDetails]="step_details">
                 </app-idex-rfp-soc>
             
                 <!-- R-AoN -->
                 <app-aon
                   *ngSwitchCase="'R-AoN'"
                   [id]="step_details.id"
                   [step]="step_details"
                   [stepDetails]="step_details">
                 </app-aon>

                 <!-- Rfp -->
                  <app-idex-rfp
                   *ngSwitchCase="'makeI_14'"
                   [id]="step_details.id"
                   [step]="step_details"
                   (routeConfig)="showConfirm()"
                   [stepDetails]="step_details">
                 </app-idex-rfp>

                 <!--  Bulk Production-->
                 <app-idex-rfp
                   *ngSwitchCase="'R_029'"
                   [id]="step_details.id"
                   [step]="step_details"
                   (routeConfig)="showConfirm()"
                   [stepDetails]="step_details">
                 </app-idex-rfp>

                 <!-- R-TEC -->
                  
                 <app-technical-eveluation
                   *ngSwitchCase="'R-TEC'"
                   [id]="step_details.id"
                   [step]="step_details"
                   (generatePDFEmitter)="generatePDF($event)"
                   [stepDetails]="step_details"
                   [schemeType]="'idex'">
                 </app-technical-eveluation>
             
                 <!-- idex_17 -->
                 <app-commercial-evaluation
                   *ngSwitchCase="'idex_17'"
                   [id]="step_details.id"
                   [step]="step_details"
                   (generatePDFEmitter)="generatePDF($event)"
                   [stepDetails]="step_details"
                   [schemeType]="'idex'">
                 </app-commercial-evaluation>
             
                 <!-- idex_19 -->
                 <app-final-offer
                   *ngSwitchCase="'idex_19'"
                   [id]="step_details.id"
                   [step]="step_details"
                   [getUrl]="'revenue/final-offer/'"
                   [postUrl]="'revenue/final-offer/'"
                   (generatePDFEmitter)="generatePDF($event)"
                   [stepDetails]="step_details"
                   [schemeType]="'idex'">
                 </app-final-offer>


             
               </ng-container>
                 <!-- oc screening application -->
                
                 <app-milestone
                     *ngIf="['MS00', 'MS01', 'MS02', 'MS03', 'MS04', 'MS05'].includes(step_details?.code)"
                     [proposalName]="proposalName"
                     [stepDetails]="step_details"
                     (routeConfig)="showConfirm()">
                   </app-milestone>
              
             </ng-template>
              </div>
              
          </div>
          
          <!-- REPORTS -->
          <div *ngIf="userGuide === 'report'">
            <ng-container *ngIf="step_details?.step_mapping?.scheme?.id === 7 && apiResponse; else generalReport">
            
              <app-report [apiResponse]="apiResponse" [schemeType]="'oc'"></app-report>
            </ng-container>
            <ng-template #generalReport>
              <app-report [apiResponse]="apiResponse" [schemeType]="'idex'"></app-report>
            </ng-template>
              
          </div>
          <!-- DOCUMENTS -->
          <div *ngIf="userGuide === 'document'" class="px-4 pt-2 pb-8">
            <div class="border border-blue-200 rounded-xl shadow bg-white">
              <!-- Header Section -->
              <div class="flex flex-col md:flex-row md:justify-between md:items-center bg-gradient-to-r from-blue-700 to-blue-500 text-white px-5 py-2 rounded-t-xl">
                <div class="flex items-center gap-3 mb-4 md:mb-0">
                  <i class="pi pi-folder-open text-3xl"></i>
                  <span class="text-2xl font-bold tracking-tight drop-shadow">Document Management</span>
                </div>
                <div class="flex flex-col md:flex-row md:items-center gap-3">
                  <button
                    class="flex items-center gap-2 bg-white/20 hover:bg-white/40 text-white border border-white/30 px-4 py-1 rounded-lg shadow-sm transition-colors focus:outline-none"
                    (click)="documentTable.clear()"
                  >
                    <i class="pi pi-filter-slash"></i>
                    <span class="font-medium">Clear Filters</span>
                  </button>
                  <div class="flex items-center bg-white/90 rounded-lg px-3 py-1 min-w-[260px] shadow-inner">
                    <i class="pi pi-search text-gray-400 text-xs mr-2"></i>
                    <input
                      pInputText
                      type="text"
                      class="border-0 outline-none bg-transparent flex-1 text-gray-700 placeholder-gray-400 px-0 py-2"
                      placeholder="Search documents..."
                      [(ngModel)]="searchText"
                      (keyup.enter)="documentTable.filterGlobal(searchText, 'contains')"
                    />
                  </div>
                </div>
              </div>

             <div class="p-2">
               <app-dmp [isEdit]="role_id === '19'" [proposalId]="proposalId"></app-dmp>

             </div>

              <!-- Document Table Section -->
              <ng-container *ngIf="documentList?.length; else noDocuments">
                <div class="bg-gradient-to-b from-amber-50 via-white to-amber-100 rounded-b-xl overflow-x-auto">
                  <p-table
                    #documentTable
                    [value]="documentList"
                    [paginator]="documentList.length > 10"
                    [rows]="10"
                    selectionMode="single"
                    styleClass="p-datatable-striped"
                    [globalFilterFields]="['name', 'type_document', 'description']"
                  >
                    <ng-template pTemplate="header">
                      <tr>
                        <th pSortableColumn="name" class="bg-blue-50">
                          <div class="flex items-center justify-between">
                            <span class="flex items-center gap-2  font-semibold"><i class="pi pi-file"></i>Document Name</span>
                            <div class="flex items-center gap-1">
                              <p-sortIcon field="name"></p-sortIcon>
                              <p-columnFilter class="text-gray-800" type="text" field="name" display="menu"></p-columnFilter>
                            </div>
                          </div>
                        </th>
                        <th pSortableColumn="description" class="bg-blue-50 max-w-xs">
                          <div class="flex items-center justify-between">
                            <span class="flex items-center gap-2  font-semibold"><i class="pi pi-align-left"></i>Description</span>
                            <div class="flex items-center gap-1">
                              <p-sortIcon field="description"></p-sortIcon>
                              <p-columnFilter class="text-gray-800" type="text" field="description" display="menu"></p-columnFilter>
                            </div>
                          </div>
                        </th>
                        <th pSortableColumn="type_document" class="bg-blue-50">
                          <div class="flex items-center justify-between">
                            <span class="flex items-center gap-2  font-semibold"><i class="pi pi-tag"></i>Type</span>
                            <div class="flex items-center gap-1">
                              <p-sortIcon field="type_document"></p-sortIcon>
                              <p-columnFilter class="text-gray-800" type="text" field="type_document" display="menu"></p-columnFilter>
                            </div>
                          </div>
                        </th>
                        <th class="bg-blue-50">
                          <div class="flex items-center  font-semibold"><i class="pi pi-calendar"></i><span class="ml-2">Uploaded At</span></div>
                        </th>
                        <th class="bg-blue-50 text-center"><span class=" font-semibold">Action</span></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                      <tr [pSelectableRow]="item" class="hover:bg-blue-100/40 transition-colors group">
                        <td class="py-3 px-2">
                          <div class="flex items-center gap-2">
                            <i class="pi pi-file text-blue-500 opacity-70 text-base"></i>
                            <span class="font-medium text-gray-900 group-hover:text-blue-700 transition-all cursor-pointer"
                              [pTooltip]="item?.name"
                              tooltipPosition="top"
                            >
                              {{ item?.name }}
                            </span>
                          </div>
                        </td>
                        <td class="py-3 px-2 max-w-xs">
                          <span class="text-gray-700" [pTooltip]="item?.description" tooltipPosition="right">
                            {{ (item?.description?.length || 0) > 60 ? (item?.description | slice: 0 : 60) + '…' : item?.description }}
                          </span>
                        </td>
                        <td class="py-3 px-2">
                          <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold bg-amber-100 text-amber-700 border border-amber-300 shadow-sm uppercase tracking-wide">
                            {{ item?.type_document || '--' }}
                          </span>
                        </td>
                        <td class="py-3 px-2 text-gray-600">
                          <span class="inline-flex items-center gap-2 text-xs">
                            <i class="pi pi-clock text-amber-400"></i>
                            {{ item?.uploaded_at | date: 'dd-MM-yyyy hh:mm a' }}
                          </span>
                        </td>
                        <td class="py-3 px-2">
                          <div class="flex gap-2 justify-center items-center">
                            <a
                              class="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-700 hover:to-blue-900 text-white shadow-lg hover:scale-105 transition-transform"
                              [href]="baseUrl + (item?.file || '')" target="_blank" rel="noopener"
                              pTooltip="Open document in new tab" tooltipPosition="left"
                            >
                              <i class="pi pi-eye"></i>
                            </a>
                            <!-- Download button -->
                            <a
                              *ngIf="item?.file"
                              [href]="baseUrl + (item?.file || '')"
                              [attr.download]="item?.name"
                              class="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-gradient-to-r from-green-400 to-green-600 hover:from-green-600 hover:to-green-800 text-white shadow-lg hover:scale-105 transition-transform"
                              pTooltip="Download document"
                              tooltipPosition="top"
                            >
                              <i class="pi pi-download"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="5" class="text-center py-16">
                          <div class="flex flex-col items-center text-sky-300 animate-fadeIn">
                            <i class="pi pi-search text-5xl mb-4"></i>
                            <p class="text-lg font-semibold mb-1">No matching documents found.</p>
                            <p class="text-sm text-gray-400">Try adjusting your filters or search terms.</p>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </ng-container>

              <!-- Empty State -->
              <ng-template #noDocuments>
                <div class="flex flex-col items-center justify-center py-20 text-gray-400 bg-slate-50 mx-6 mt-6 rounded-lg shadow-inner border-2 border-dashed border-blue-200 animate-fadeIn">
                  <i class="pi pi-folder-open text-[5rem] mb-6 animate-bounce opacity-60"></i>
                  <p class="text-xl font-bold mb-2 tracking-tight">No documents uploaded yet.</p>
                  <p class="text-base text-gray-500 mb-2">Get started by uploading your first document.</p>
                  <div class="flex gap-2">
                    <span class="inline-flex items-center rounded px-3 py-1 bg-blue-100 text-blue-700 text-xs font-normal shadow-sm">
                      <i class="pi pi-info-circle mr-2"></i> Only authorized users can upload.
                    </span>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <!-- Comments -->
        <div *ngIf="userGuide === 'comments'">
          <div class="bg-white rounded shadow p-3 sticky top-4">
            <app-commenting-seet [id]="step_details.id" [stepDetails]="step_details"></app-commenting-seet>
          </div>
        </div>
      </div>
    </div>
  
  

  <p-toast position="center" key="confirm" [baseZIndex]="9999">
    <ng-template let-message pTemplate="message">
      <div class="flex flex-col w-full p-1">
        <div class="flex items-center gap-3 mb-4 bg-blue-50 p-3 rounded-xl border border-blue-100">
          <div class="w-10 h-10 bg-blue-600 text-white rounded-lg flex items-center justify-center shadow-lg">
            <i class="pi pi-send"></i>
          </div>
          <div>
            <h4 class="text-sm font-black text-blue-900 uppercase tracking-tighter">Action Required</h4>
            <p class="text-[10px] text-blue-700 font-medium">Step: {{ step_details?.name }}</p>
          </div>
        </div>

            <textarea
              class="w-full min-h-[60px] rounded-md border border-slate-300 p-2 mb-3 text-xs font-medium text-slate-700 resize-y focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
              placeholder="Add a comment or remarks for this action (optional)..."
              [(ngModel)]="comment"
            ></textarea>
        
        <div class="flex flex-col gap-2">
          <button (click)="submitProposal(2)"
            class="w-full py-3 bg-blue-950 hover:bg-slate-900 text-white rounded-xl shadow-lg transition-all flex items-center justify-center gap-2 active:scale-95">
            <i class="pi pi-check-circle"></i>
            <span class="text-xs font-bold uppercase">Submit & Forward</span>
          </button>
  
          <div class="grid grid-cols-2 gap-2 mt-1">
            <button (click)="trigarFromChild()"
              class="py-2.5 bg-white border border-slate-200 hover:border-blue-300 text-slate-700 rounded-xl text-[10px] font-bold uppercase transition-all flex items-center justify-center gap-2">
              <i class="pi pi-cog"></i> Route Config
            </button>
            <button (click)="submitProposal(1)"
              class="py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl text-[10px] font-bold uppercase transition-all flex items-center justify-center gap-2">
              <i class="pi pi-save"></i> Save Draft
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-toast>
  